<template>
    <div class="field">
        <label class="label">Km's range</label>
        <div class="field has-addons has-addons-right">
            <p class="control">
                <span class="select is-fullwidth">
                    <select v-model="minKm">
                        <option v-for="km in kms" :value="km">{{ km | formatNumber }}</option>
                    </select>
                </span>
            </p>
            <p class="control helper-to">
                <span class="button is-static">To:</span>
            </p>
            <p class="control">
                <span class="select is-fullwidth">
                   <select v-model="maxKm">
                        <option v-for="km in kms" :value="km">{{ km | formatNumber}}</option>
                   </select>
                </span>
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        components: {

        },
        data() {
            return {
                kms: [],
            }
        },
        computed: {
            minKm: {
                get: function () {
                    return this.$store.getters.getQueryKmMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewKmRangeMinValue', value)
                }
            },
            maxKm: {
                get: function () {
                    return this.$store.getters.getQueryKmMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewKmRangeMaxValue', value)
                }
            }
        },
        methods: {
            generateKmsArrays() {
                let minOffset = 0, maxOffset = 30;
                let thisKms = 30;
                let kms = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    let newKms = (thisKms - i) * 10000;
                    kms.push(newKms);
                }

                this.kms = kms
            }
        },
        created() {
            this.generateKmsArrays()
        }
    }
</script>

<style scoped>
    .control {
        width: 100%;
    }
    .helper-to {
        width: 50px;
    }
</style>




// WEBPACK FOOTER //
// src/components/Auctions/Specification/KmRangeSlider.vue